import { render } from "./Index.vue?vue&type=template&id=26f55426&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-26f55426"

export default script